import Components from '../../Components';
import { MEETING_ROOM_SEARCH_PATH } from './constants';

const { containerTypes } = Components.Routes;

const RouteConfig = {
  path: MEETING_ROOM_SEARCH_PATH,
  exact: true,
  name: 'navigation.menu.meetingRoomSearch',
  private: true,
  type: containerTypes.PAGE,
  requiresMemberPortalAccess: true,
  isHardRedirect: true,
};

export default RouteConfig;
